export const NEW = 'new';
export const FINISHED = 'finished';
export const APPROVED = 'approved';